export class ProductBatchItemFromFileUpdatePriceModel {
	skuCode?: string|number|null = null;
	codeSource?: string|number|null = null;
	listPrice: string|number|null = null;
	sellPrice: string|number|null = null;

	constructor(p?: Partial<ProductBatchItemFromFileUpdatePriceModel>) {
		Object.assign(this, p)
	}
}
